import { useEffect, useRef, useState } from 'react';

const useDelayedAction = (delay: number, action: () => void) => {
  const [started, setStarted] = useState(false);
  const actionRef = useRef(action);
  actionRef.current = action;

  useEffect(() => {
    if (!started) {
      return;
    }

    setTimeout(() => {
      actionRef.current();
      setStarted(false);
    }, delay);
  }, [started, delay, actionRef]);

  return {
    trigger: () => setStarted(true),
  };
};

export default useDelayedAction;
